import React, { useEffect, useState } from 'react';
import { API_BASE_URL, DownloadTypes } from '../data/objects/gameColor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDown, faDownload } from '@fortawesome/free-solid-svg-icons';
import HoverInfo from './HoverInfo';
import { Addon } from '../data/interfaces/Addon';
import { Variation } from '../data/interfaces/Variation';

interface DownloadOptionsButtonProps {
    variationPath: string;
    variation?: Variation;
    addon?: Addon;
}

const DownloadOptionsButton: React.FC<DownloadOptionsButtonProps> = ({ variationPath, variation, addon }) => {
    const [downloadOptions, setDownloadOptions] = useState<{ [key: string]: string[] }>({});
    const [isLoading, setIsLoading] = useState(true);

    const installInstructions =
        addon?.howToInstall ??
        variation?.howToInstall ??
        [];

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/list-downloads?path=${variationPath}`)
            .then((response) => response.json())
            .then((data) => {
                setDownloadOptions(data.downloadTypes || {});
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching download options:', error);
                setIsLoading(false);
            });
    }, [variationPath]);

    return (
        <>
            <button
                className="btn btn-primary col-12 mt-3 kanit-regular"
                data-bs-toggle="modal"
                data-bs-target="#downloadOptionsModal"
            >
                <FontAwesomeIcon icon={faCircleDown} className="me-2 fa-xl" />
                Download Options
            </button>

            {/* Modal */}
            <div
                className="modal fade"
                id="downloadOptionsModal"
                tabIndex={-1}
                aria-labelledby="downloadOptionsModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="downloadOptionsModalLabel">
                                Download Options
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            {isLoading ? (
                                <p>Loading...</p>
                            ) : Object.keys(downloadOptions).length === 0 ? (
                                <p>No downloads available.</p>
                            ) : (
                                Object.entries(downloadOptions).map(([folder, files]) => {

                                    const instructionsForDownload =
                                        installInstructions.find((x) => x.download === folder)?.instructions ?? null;

                                    console.log(instructionsForDownload);

                                    return (
                                        <div key={folder} className="mb-4">
                                            <h6 className="d-flex align-items-center gap-2 mb-2">
                                                <span>{DownloadTypes[folder] || folder}</span>

                                                {instructionsForDownload && (
                                                    <HoverInfo instructions={instructionsForDownload} />
                                                )}
                                            </h6>

                                            {files.map((file, index) => (
                                                <a
                                                    key={index}
                                                    href={file}
                                                    className="btn btn-secondary me-2 direct-link"
                                                    download
                                                >
                                                    <FontAwesomeIcon icon={faDownload} className="me-2 fa-xl" />
                                                    Download {file.split('/').pop()}
                                                </a>
                                            ))}
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DownloadOptionsButton;

